import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { useStore } from '../../../app/stores/store';
import { Activity } from '../../../app/models/activity';
import _ from 'lodash';
import { Button, ButtonGroup, ButtonOr, Form, Grid, Header, Input, Segment, TextArea } from 'semantic-ui-react';
import { HFCShipperInfo, HFCShipperInfoInitialdata } from '../../../app/models/ReceivingDelivery';
import MovetoVaultModal from './MovetoVaultModal';
import agent from '../../../app/api/agent';


function Returning() {
    const{activityStore, userStore, dashboardStore, vaultStore}= useStore()
    const [pageNumber, setPageNumber] = useState(1);
    const[receiving, setReceiving]=useState<HFCShipperInfo>(HFCShipperInfoInitialdata)
    const[isModal,SetIsModal]=useState(false)
    const [containerListData, setContainerListData] = useState<any[]>([]);

    const postsPerPage = 5

    const validateFormValues = () => {
      const {
        title,
        asset_ID,
        print,
        vault,
        shipping_Date,
        return_Date,
        assets_Associated_with_Title_and_Asset_ID
      } = receiving;
    
      return (
        title.trim() !== '' &&
        asset_ID.trim() !== '' &&
        print.trim() !== '' &&
        vault.trim() !== '' &&
        shipping_Date.trim() !== '' &&
        return_Date.trim() !== '' &&
        assets_Associated_with_Title_and_Asset_ID.trim() !== ''
      );
    };
    
    

    useEffect(() => {
      const fetchData = async () => {
        if (activityStore.selectedReturn && 
            dashboardStore.dashboard.valueForL3Orders === "Returning Services") {
          setReceiving(activityStore.selectedReturn);
        }
      };
    
      fetchData();
    // eslint-disable-next-line
    }, [activityStore.selectedReturn]);

    useEffect(()=>{
        const pageSize=5
        activityStore.HFCReturningloadActivitiesPagination(pageNumber, userStore?.user!.id, pageSize, []) 
     // eslint-disable-next-line
    },[])

    useEffect(()=>{
      setReceiving(HFCShipperInfoInitialdata);
    },[])


    const moveHandler = async()=>{
      setReceiving(HFCShipperInfoInitialdata)
      SetIsModal(true);
      vaultStore.getHFCVaultList()
      const array_of_strings = receiving.asset_ID.split(' ')
      const scanRes= await agent.HFC.HFCscanAssetBarcodes(array_of_strings)
      const containerBarcode = scanRes.data
      const containerList = containerBarcode.map((item:any)=>{
        return{
          key:item,
          value:item,
          text:item
        }
      })
      setContainerListData(containerList)
    }
  
    const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';
    const tableData: Activity[] = [];

    activityStore.activitiesByDate?.forEach((a: any) => {
        // isMaster
        delete a?.isMaster;
        // eslint-disable-next-line
        delete a?.sections_Multiple_From;
        delete a?.sections_From;
        delete a?.synopsis;
    
        tableData?.push({
          ...a,
          //  movementdate:userReadableDateFormat(a.movementdate),
          //  movement_Time:userReadableDateFormat(a.movement_Time),
          //  maintenance:userReadableDateFormat(a.maintenance),
          //  receivingdate:userReadableDateFormat(a.receivingdate),
          //  status_Time: userReadableDateFormat(a.status_Time),
          //  itemCreatedAt:userReadableDateFormat(a.itemCreatedAt)
        });
      });
      const createOrderFilter = tableData?.filter((x) => x?.isReceiving === false);
      const MainFilter =
        dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Create Order Receiving'
          ? createOrderFilter
          : tableData;
    
      const removeCol =
        'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,inactive,isgoing,ishost,clearedon';
      const assettable = JSON.parse(JSON.stringify(MainFilter));
      assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

      const paginateFunction = (e: number) => {
        const resultArray = Object.entries(dashboardStore.dashboard.searchfilterparams).map(([header, searchValue]) => ({
          header,
          searchValue
        }));
        if (
          !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
          Object.values(dashboardStore.dashboard.searchfilterparams).every(
            (o) => o !== '',
          ) &&
          dashboardStore.dashboard.orderData === '' &&
          dashboardStore.dashboard.orderName === ''
        ) {
          activityStore.HFCReceivingsearchListItems(resultArray,
            e,
            postsPerPage) 
        } else if (
          dashboardStore.dashboard.orderData !== '' &&
          dashboardStore.dashboard.orderName !== ''
        ) {
          activityStore.sortListItems(
            dashboardStore.dashboard.orderName,
            dashboardStore.dashboard.orderData,
            e,
            postsPerPage,
          ); 
        } else {
          activityStore.HFCShipperloadActivitiesPagination(e, userID, postsPerPage);
        }
        dashboardStore.setTagPageNumFunc(e);
        setPageNumber(e);
      };
      const searchFunction = (column: any, order: any) => {
        console.log(order, column);
      };
      const handleCancel = ()=>{
        setReceiving(HFCShipperInfoInitialdata)
      }
  return (
    <>
        <div id="parent-grid-receiving">
    <Segment clearing className="register-form-segment ui clearing segment register-form-segment">
    <Form>
        <Header
            clearing
            icon="edit"
            size="huge"
            dividing
            as="h1"
            content="Receiving Request"
            sub
            color="grey"
        />
        <Grid stretched columns={4} style={{marginTop: "10px"}}>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Title</label>
                <Input
                name="title"
                placeholder="Title"
                value={receiving.title}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Asset Id</label>
                <Input
                name="asset_Id"
                placeholder="Asset Id"
                value={receiving.asset_ID}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Print #</label>
                <Input
                name="print"
                placeholder="Print"
                value={receiving.print}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Vault</label>
                <Input
                name="vault"
                placeholder="Vault"
                value={receiving.vault}
                />
            </Form.Field>
            
            </Grid.Column>
        </Grid>
        <Grid stretched columns={3} style={{marginTop: "10px"}}>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Shipping Date</label>
                <Input
                name="shipping_Date"
                placeholder="Shipping Date"
                value={receiving.shipping_Date}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Return Date</label>
                <Input
                name="return_Date"
                placeholder="Return Date"
                value={receiving.return_Date}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Where it Come From</label>
                <Input
                name="location"
                placeholder="Location"
                value={receiving.shipping_Location}
                />
            </Form.Field>
            </Grid.Column>
           
        </Grid>
        <Grid stretched columns={2}>
          <Grid.Column>
            <Form.Field>
            <label className="mandatory-label">Address</label>
            <TextArea value={receiving.address}/>
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
            <label className="mandatory-label">Assets Associated  W/Title & Asset Id</label>
            <TextArea value={receiving.assets_Associated_with_Title_and_Asset_ID}/>
            </Form.Field>
          </Grid.Column>
          
        </Grid>
        <div style={{textAlign: 'right', marginTop:'20px'}}>
        <ButtonGroup>
            <Button   onClick={handleCancel}>Cancel</Button>
            <ButtonOr/>
            <Button  primary disabled={!validateFormValues()} onClick={moveHandler}>Move to</Button>
        </ButtonGroup>
        </div>
    </Form>
    </Segment>
    </div>
        <DynamicTableComponent data={assettable} name={'HFCShipper'} actiontype={''} pageFunc={paginateFunction} pageNumData={pageNumber} searchFuncData={searchFunction}/>
        {
          isModal ?  <MovetoVaultModal isModal={isModal} setIsModal={SetIsModal} scanData={containerListData} receiving={activityStore.selectedReturn} setIssubmit={()=>{}}/> : null
        }
       
    </>
  )
}

export default observer(Returning)